import { PathTypes } from './path.actions'
import * as R from 'ramda'

export const pathReducers = (state = [], action: any) => {
  switch (action.type) {
    case PathTypes.APPEND_POINT: {
      const point = [action.payload.lat as number, action.payload.lng as number]
      const path = R.append(point, [...state])

      return path
    }
    case PathTypes.REMOVE_POINT: {
      const index = action.payload

      const path = R.remove(index, 1)([...state])

      return path
    }
    case PathTypes.SET_ACTIVE_POINT: {
      return action.payload
    }
    case PathTypes.MOVE_POINT: {
      return R.move(action.payload[0], action.payload[1])(state)
    }
    case PathTypes.CLEAR_PATH: {
      return []
    }
    default:
      return state
  }
}
